export default function isPrimitive(value) {
  const type = typeof value;
  return (
    type === 'number' ||
    type === 'string' ||
    type === 'boolean' ||
    type === 'undefined' ||
    value === null
  );
}
